import Alpine from 'alpinejs';

Alpine.data('header', () => ({
    mobileMenuOpen: false,
    languageMenuOpen: false,
    desktopMenu: false,
    tabletMenu: false,
    onResize() {
        this.mobileMenuOpen = false;
        this.desktopMenu = !this.$refs.mobileMenuButton.offsetParent;
        this.tabletMenu = window.innerWidth >= 768;
    },
    init() {
        this.onResize();
    },
    mobileMenuButton: {
        'x-on:click'() {
            this.mobileMenuOpen =! this.mobileMenuOpen
            if (this.mobileMenuOpen) {
                this.languageMenuOpen = false
            }
        }
    },
    languageMenuButton: {
        'x-on:click'() {
            this.languageMenuOpen =! this.languageMenuOpen
            if (this.languageMenuOpen) {
                this.mobileMenuOpen = false
            }
        }
    },
    header: {
        // We use throttle and debounce, throttle alone could miss the final event
        'x-on:resize.window.passive.throttle'() {
            this.onResize();
        },
        'x-on:resize.window.passive.debounce'() {
            this.onResize();
        },
        'x-on:keydown.window.escape'() {
            this.mobileMenuOpen = false;
            this.languageMenuOpen = false;
        },
        'x-trap.inert'() {
            return this.mobileMenuOpen || this.languageMenuOpen;
        },
        'x-on:click.outside'() {
            this.mobileMenuOpen = false;
            this.languageMenuOpen = false;
        },
    },
}));
